<template>
	<div v-if="currentEvent" class="container col-xxl-10 px-3 py-3">
		<div class="row flex-lg-row-reverse align-items-center">
			<div class="col-12 col-sm-12 col-lg-6">
				<img :src="currentEvent.image" class="d-block mx-lg-auto img-fluid rounded-3" :alt="currentEvent.title" />
				<div class="d-flex justify-content-around mt-2">
					<p class="text-muted small text-center mb-1">
						Тип:<br /><b>{{ currentEvent.typeText }}</b>
					</p>
					<p class="text-muted small text-center mb-1">
						Проект:<br />
						<b>{{ currentEvent.projectText }}</b>
					</p>
					<p class="text-muted small text-center mb-1">
						Участников:<br />
						<b
							>{{ partisipantsCount
							}}<span v-if="currentEvent.maxCompetitors > 0">/{{ currentEvent.maxCompetitors }}</span></b
						>
					</p>
				</div>

				<div class="bg-light border rounded-3 p-2 my-2">
					<div class="d-flex justify-content-around fs-4 flex-column flex-sm-row align-items-center py-2">
						<div class="text-center">Начало</div>
						<div>
							<i class="bi bi-calendar-check"></i>&nbsp;<span>{{ currentEvent.dateStart | moment("DD.MM.YYYY") }}</span>
						</div>
						<div>
							<i class="bi bi-clock"></i>&nbsp;<span>{{ currentEvent.dateStart | moment("HH:mm") }}</span>
						</div>
						<div v-if="currentEvent.maxCompetitors > 0">
							<i class="bi bi-people"></i>&nbsp;<span>до {{ currentEvent.maxCompetitors }}</span>
						</div>
					</div>
				</div>

				<div class="bg-light border rounded-3 p-2 my-2" v-if="currentEvent.dateEnd">
					<div class="d-flex justify-content-around fs-4 flex-column flex-sm-row align-items-center py-2">
						<div class="text-center">{{ currentEventEnded ? "Завершено" : "Завершится" }}</div>
						<div>
							<i class="bi bi-calendar-check-fill"></i>&nbsp;<span>{{
								currentEvent.dateEnd | moment("DD.MM.YYYY")
							}}</span>
						</div>
						<div>
							<i class="bi bi-clock-fill"></i>&nbsp;<span>{{ currentEvent.dateEnd | moment("HH:mm") }}</span>
						</div>
					</div>
				</div>
				<div class="d-flex justify-content-center align-items-center my-3" v-if="userCanEdit">
					<button type="button" class="btn btn-outline-warning btn-md-lg px-4" @click="editEvent()">Изменить</button>
					<button type="button" class="btn btn-outline-info btn-md-lg px-4 ml-2" @click="statsEvent()">
						Статистика
					</button>
					<br />
				</div>
				<div class="text-center text-muted my-3">
					<template v-if="!currentEventEnded">
						<button type="button" v-if="!userParticipant" class="btn btn-primary btn-md-lg px-4" @click="joinEvent()">
							{{ currentEvent.joinText }}
						</button>
						<span v-else>Вы уже зарегистрированы на это событие</span>
					</template>
					<template v-else>
						<span>Событие завершено</span>
						<br />
						<span v-if="userParticipant">Вы принимали участие.</span>
					</template>
				</div>
			</div>
			<div class="col-lg-6">
				<h1 class="display-5 fw-bold lh-1 mb-3">{{ currentEvent.title }}</h1>
			</div>
		</div>

		<div class="row">
			<div class="col-lg-12">
				<div v-html="currentEvent.description" class="content"></div>
				<template v-if="userParticipant && currentEvent.extendedData !== ''">
					<hr />
					<h4>Блок для зарегистрированных участников</h4>
					<div v-html="currentEvent.extendedData" class="alert alert-secondary content"></div>
				</template>
			</div>
		</div>

		<sweet-modal icon="success" ref="okModal">
			{{ successMsg }}
			<sweet-button class="btn btn-success" slot="button" @click="closeModal()"> Ок</sweet-button>
		</sweet-modal>
		<sweet-modal icon="error" blocking ref="errModal">
			{{ errorMsg }}
			<sweet-button v-if="errorRoute" class="btn btn-danger" slot="button" @click="goToRoute(errorRoute)">{{
				errorBtnText
			}}</sweet-button>
			<sweet-button v-else class="btn btn-danger" slot="button" @click="closeModal()"> Закрыть</sweet-button>
		</sweet-modal>
	</div>
</template>

<script>
import { mapGetters } from "vuex";

import EventDataService from "../services/event.service";
import ParticipantsDataService from "../services/participants.service";
import moment from "moment";

export default {
	name: "event-details",

	metaInfo() {
		return {
			title: this.pageTitle,
			meta: [{ name: "description", content: this.pageDescription }],
		};
	},
	data() {
		return {
			currentEvent: {},
			//meta
			pageTitle: undefined,
			pageDescription: undefined,

			partisipantId: null,
			userParticipant: false,
			partisipantsCount: 0,
			errorMsg: "",
			errorBtnText: "",
			errorRoute: null,
			successMsg: "",
		};
	},
	computed: {
		...mapGetters({
			getEventType: "params/GET_EVENT_TYPE",
			getProject: "params/GET_PROJECT",
		}),
		currentUser() {
			return this.$store.state.auth.user;
		},
		loggedIn() {
			return this.$store.state.auth.status.loggedIn;
		},
		userCanEdit() {
			if (this.currentUser && this.currentUser.roles) {
				return this.currentUser.roles.includes("ROLE_ADMIN", "ROLE_MODERATOR");
			}
			return false;
		},
		currentEventEnded() {
			if (this.currentEvent.dateEnd === null) {
				//если нет даты завершения, сраниваем с окончанием дня
				return moment().diff(moment(this.currentEvent.dateStart).endOf("day"), "minutes") > 0;
			} else {
				return moment().diff(moment(this.currentEvent.dateEnd), "minutes") > 0;
			}
		},
	},
	methods: {
		async getEvent(id) {
			try {
				let eventResponse = await EventDataService.get(id);
				this.currentEvent = eventResponse.data;

				let typeParams = this.getEventType(this.currentEvent.type);
				if (typeParams) {
					this.currentEvent.joinText = typeParams.joinText;
					this.currentEvent.typeText = typeParams.name;
				}

				let projectParams = this.getProject(this.currentEvent.project);
				if (projectParams) {
					this.currentEvent.projectText = projectParams.name;
				}

				this.currentEvent.image = this.currentEvent.gridImage;

				this.pageTitle = this.currentEvent.title;
				this.pageDescription = this.currentEvent.description;
				if (!this.pageTitle) {
					this.pageTitle = undefined;
					this.pageDescription = undefined;
				}
				this.currentEvent.extendedData = "";
				//get users count
				try {
					let eventParticipationsCount = await ParticipantsDataService.getEventParticipantsCount(this.currentEvent);
					this.partisipantsCount = eventParticipationsCount.data.length;
				} catch (err) {
					if (err.response.status === 404) {
						this.errorMsg = err.response.data.message;
					} else {
						this.errorMsg = err.response.data.message;
					}

					this.$refs.errModal.open();
				}
			} catch (err) {
				if ([404].includes(err.response.status)) {
					this.$router.push({ name: "404-page" });
				}
			}
		},
		editEvent() {
			this.$router.push({ name: "event-edit", params: { id: this.currentEvent._id } });
		},
		statsEvent() {
			this.$router.push({ name: "event-stats", params: { id: this.currentEvent._id } });
		},
		async getEventExtData() {
			if (this.partisipantId != "") {
				try {
					let eventExtData = await ParticipantsDataService.getExtendedEventData(
						this.partisipantId,
						this.currentEvent._id
					);

					this.currentEvent.extendedData = eventExtData.data.afterJoinText;
				} catch (err) {
					this.errorMsg = err.response.data.message;
					this.$refs.errModal.open();
				}
			}
		},
		async joinEvent() {
			let event = this.currentEvent;
			let user = this.currentUser;

			if (this.loggedIn && user.id && event._id) {
				try {
					let participation = await ParticipantsDataService.create(event, user);
					this.partisipantId = participation.data._id;

					let eventParticipation = null;

					eventParticipation = await ParticipantsDataService.checkParticipation(event, user);
					if (eventParticipation.data._id && eventParticipation.data._id.length == 24) {
						this.userParticipant = true;
						this.partisipantId = eventParticipation.data._id;
						this.currentEvent.extendedData = eventParticipation.data.event.afterJoinText;
					}

					this.userParticipant = true;
					this.successMsg = "Вы успешно зарегистрировались на событие";
					this.$refs.okModal.open();
				} catch (err) {
					if ([401, 403].includes(err.response.status)) {
						this.$store.commit("auth/LOGOUT");
						this.errorMsg = "Сессия истекла. Войдите в ваш личный кабинет";
						this.errorRoute = "login-page";
						this.errorBtnText = "Вход";
					} else {
						this.errorMsg = err.response.data.message;
						this.errorRoute = err.response.data.route;
						this.errorBtnText = err.response.data.route != "" ? err.response.data.route : "Закрыть";
					}
					this.$refs.errModal.open();
				}
			} else {
				this.$store.dispatch("auth/logout");

				this.$router.push({
					name: "login-page",
					params: { redirect: this.$router.history.current.path },
				});
			}
		},
		async checkParticipation() {
			let event = this.currentEvent;
			let user = this.currentUser;

			if (this.loggedIn && user.id && event._id) {
				let eventParticipation = null;

				try {
					eventParticipation = await ParticipantsDataService.checkParticipation(event, user);

					if (eventParticipation.data._id && eventParticipation.data._id.length == 24) {
						this.userParticipant = true;
						this.partisipantId = eventParticipation.data._id;
						this.currentEvent.extendedData = eventParticipation.data.event.afterJoinText;
					}
				} catch (err) {
					if ([401, 403].includes(err.response.status)) {
						this.$store.commit("auth/LOGOUT");
						this.errorMsg = "Сессия истекла. Войдите в ваш личный кабинет";
						this.errorRoute = "login-page";
						this.errorBtnText = "Вход";
					} else {
						this.errorMsg = err.response.data.message;
						this.errorRoute = err.response.data.route;
						this.errorBtnText = err.response.data.route != "" ? err.response.data.route : "Закрыть";
					}
					this.$refs.errModal.open();
				}
			}
		},

		goToRoute(route) {
			this.$router.push({ name: route });
		},
		closeModal() {
			this.$refs.okModal.close();
			this.$refs.errModal.close();
		},
	},
	async mounted() {
		await this.getEvent(this.$route.params.id);
		if (this.loggedIn && this.currentEvent && this.currentUser) {
			await this.checkParticipation();
		}
	},
};
</script>

<style>
.content img {
	max-width: 100%;
	height: auto;
	width: auto;
	height: auto;
}

.content a {
	/* These are technically the same, but use both */
	overflow-wrap: break-word;
	word-wrap: break-word;

	-ms-word-break: break-all;
	/* This is the dangerous one in WebKit, as it breaks things wherever */
	word-break: break-all;
	/* Instead use this non-standard one: */
	word-break: break-word;

	/* Adds a hyphen where the word breaks, if supported (No Blink) */
	-ms-hyphens: auto;
	-moz-hyphens: auto;
	-webkit-hyphens: auto;
	hyphens: auto;
}
</style>
